// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Tensor as TensorImpl } from './tensor-impl.js';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Tensor = TensorImpl;
//# sourceMappingURL=tensor.js.map